import { ArchiveBoxIcon, DocumentTextIcon, HomeIcon, LifebuoyIcon } from "@heroicons/react/24/outline";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import AuthenticatedRoute from "./common/components/AuthenticatedRoute";
import AuthenticationCallback from "./common/components/AuthenticationCallback";
import LogoutCallback from "./common/components/LogoutCallback";
import Active from "./pages/Active/Index";
import Results from "./pages/Results";
import EmailChange from "./common/pages/EmailChange";
import History from "./pages/History";
import PageNotFound from "./common/pages/PageNotFound";
import PasswordChange from "./common/pages/PasswordChange";
import PhoneNumberChange from "./common/pages/PhoneNumberChange";
import ProfileUpdate from "./common/pages/ProfileUpdate";
import Dashboard from "./pages/Dashboard/Dashboard";
import Support from "./pages/Support";
import RegistrationForm from './components/RegistrationForm';
import VerificationForm from "./components/VerificationForm";
import LoginForm from "./components/LoginForm";
import LogoutPage from "./pages/Logout";
import ForgotPassword from "./components/forgotPassword";

const navigation = [
  { name: "Home", href: "/dashboard", icon: HomeIcon },
  { name: "Kit Registration", href: "/active", icon: DocumentTextIcon },
  { name: "Test Results", href: "/history", icon: ArchiveBoxIcon },
  { name: "Contact Support", href: "/support", icon: LifebuoyIcon },
];

const userNavigation = [
  { name: "Update profile", href: "/profile-update" },
  { name: "Change email", href: "/email-change" },
  { name: "Change phone number", href: "/phone-number-change" },
  { name: "Change password", href: "/password-change" },
  { name: "Sign out", href: "/auth/logout" },
];

function App() {
  return (
    <Router>
      <div className="w-full mx-auto">
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/register" element={<RegistrationForm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify" element={<VerificationForm />} />
          <Route path="/login" element={<LoginForm />} />
          <Route
            path="/dashboard"
            element={
              <AuthenticatedRoute
                component={Dashboard}
                title="Home"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/active"
            element={
              <AuthenticatedRoute
                component={Active}
                title="Active analysis"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/history"
            element={
              <AuthenticatedRoute
                component={History}
                title="Previous analysis"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/results"
            element={
              <AuthenticatedRoute
                component={Results}
                title="Results"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/support"
            element={
              <AuthenticatedRoute
                component={Support}
                title="Support"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/profile-update"
            element={
              <AuthenticatedRoute
                component={ProfileUpdate}
                title="Profile update"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/password-change"
            element={
              <AuthenticatedRoute
                component={PasswordChange}
                title="Password change"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/email-change"
            element={
              <AuthenticatedRoute
                component={EmailChange}
                title="Email change"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route
            path="/phone-number-change"
            element={
              <AuthenticatedRoute
                component={PhoneNumberChange}
                title="Phone number change"
                navigation={navigation}
                userNavigation={userNavigation}
              />
            }
          />
          <Route path="/auth/login" element={<AuthenticationCallback />} />
          <Route path="/auth/logout" element={<LogoutCallback />} />
          <Route path="/logout" element={<LogoutPage />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>

        <ToastContainer autoClose={3000} />
      </div>
    </Router>
  );
}

export default App;
